import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';

export default {
    name: 'reportDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            reports: [],
            search: {
                months: '',
                years: '',
                keywords: '',
                reportType:''
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            reportTypeCustomFieldId:2,
            reportTypes:[],
            years: [],
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.initializeYears();

            vm.getCustomFields([
                vm.reportTypeCustomFieldId,
            ]).then(function (res) {
                vm.reportTypes = res.data[vm.reportTypeCustomFieldId];
            }).catch(function (err) {
                console.log(err);
                return err
            })

            return vm.getReports()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.reports = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        initializeYears() {
            let vm = this;
            let now = new Date();
            for (let year = now.getFullYear() ; year >= 1900 ; year--) {
                vm.years.push(String(year));
            }
        },
        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getReports()
                .then(function (res) {
                    vm.reports = vm.reports.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            vm.getReports()
                .then(function (res) {
                    vm.reports = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getReports() {
            let vm = this;
            return axiosCommon.get(`o/reports?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&months=${vm.search.months.toString()}&years=${vm.search.years.toString()}&keywords=${vm.search.keywords}&reportType=${vm.search.reportType?vm.search.reportType:''}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        },
        getCustomFields(ids) {
            let vm = this;

            let customFieldsURL = 'o/customFields?';

            for (let [index, id] of ids.entries()) {
                if (index == 0) {
                    customFieldsURL += `id=${id}`
                } else {
                    customFieldsURL += `&id=${id}`
                }
            }
            return axiosCommon.get(customFieldsURL)
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/report-dashboard/report-dashboard.js